import React from "react";
import { Route, Switch } from "react-router-dom";
import "./style.scss";

import { useTranslation } from "react-i18next";
import { BuildingOperationOverviewView } from "./OperationOverview";
import { BuildingOperationDetailsView } from "./OperationDetails";

export const BuildingOperationsView = () => {
   const [t] = useTranslation();

   return (
      <>
         <Switch>
            <Route
               exact
               path="/buildings/:id/operations"
               component={BuildingOperationOverviewView}
            ></Route>
            <Route
               exact
               path="/buildings/:id/operations/:operation_id"
               component={BuildingOperationDetailsView}
            ></Route>
         </Switch>
      </>
   );
};
